import AltRouteIcon from '@mui/icons-material/AltRoute';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { Box, Chip, Grid, Typography } from '@mui/material';
import React from 'react';
import { publicCardSx, publicColors, publicContainerSx, publicH2Sx, publicSectionSx, publicSubtitleSx } from './publicTheme';

const features = [
    {
        icon: DashboardIcon,
        title: 'Dashboard por período',
        description: 'Veja vendas, impressões, sucessos, falhas, cancelamentos e produção em andamento. Compare períodos e entenda como o seu negócio está evoluindo.',
        tag: 'Resultados',
    },
    {
        icon: PrecisionManufacturingIcon,
        title: 'Pedidos, impressões e impressoras',
        description: 'Organize o que precisa ser produzido e acompanhe o histórico das impressões. Veja desempenho, falhas, consumo estimado de filamento e, com o Farm Link, acompanhe suas impressoras de diversas marcas em tempo real*.',
        tag: 'Produção',
    },
    {
        icon: ReceiptLongIcon,
        title: 'Vendas e pedidos',
        description: 'Registre vendas feitas pelo Instagram, WhatsApp, lojas, feiras, encomendas ou marketplaces. Use o Quick Checkout* para registrar vendas apenas tirando foto pelo seu smartphone e organize pedidos e clientes em um só lugar.',
        tag: 'Vendas',
    },
    {
        icon: AltRouteIcon,
        title: 'Precificação e custos',
        description: 'Calcule o custo real dos seus produtos considerando material, energia, tempo, embalagem e outros custos da operação. Defina seu preço antes de vender e saiba qual margem está praticanto em cada venda.',
        tag: 'Transparência',
    },
];

const Advantages = () => (
    <Box id="metricas" component="section" sx={{ ...publicSectionSx, bgcolor: publicColors.surfaceAlt }}>
        <Box sx={publicContainerSx}>
            <Typography component="h2" sx={{ ...publicH2Sx, textAlign: 'center' }}>
                Ferramentas para entender e cuidar do seu negócio
            </Typography>
            <Typography sx={{ ...publicSubtitleSx, textAlign: 'center', mb: 5 }}>
                Do primeiro pedido à produção e ao resultado da venda, tenha os dados da sua operação organizados para saber o que está acontecendo e quanto está ganhando.
            </Typography>
            <Grid container spacing={3}>
                {features.map(({ icon: Icon, title, description, tag }) => (
                    <Grid item xs={12} sm={6} md={3} key={title}>
                        <Box sx={publicCardSx}>
                            <Chip
                                label={tag}
                                size="small"
                                sx={{
                                    mb: 2,
                                    bgcolor: publicColors.surfaceAlt,
                                    color: publicColors.inkSoft,
                                    fontWeight: 600,
                                    border: `1px solid ${publicColors.border}`,
                                }}
                            />
                            <Icon sx={{ fontSize: 32, color: publicColors.primary, mb: 1.5 }} />
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: publicColors.ink, mb: 1 }}>
                                {title}
                            </Typography>
                            <Typography variant="body2" sx={{ color: publicColors.inkMuted, lineHeight: 1.65 }}>
                                {description}
                            </Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>
            <Typography
                variant="caption"
                display="block"
                textAlign="center"
                sx={{ mt: 4, color: publicColors.inkSoft }}
            >
                Recursos marcados com * estão disponíveis apenas para os planos pagos.
                <br />
                O Acompanha 3D é o único sistema de gestão que conecta com impressoras das principais fabricantes como <strong>Bambu Lab, Creality, Anycubic, Flashforge</strong>, entre outras.
            </Typography>
        </Box>
    </Box>
);

export default Advantages;
